<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="修改收货信息" :visible.sync="dialogVisible" destroy-on-close width="1000px">
		<div class="shiplist">
			<el-row>
				<el-col :span="8" v-for="(item, index) in list" :key="item.id">
					<div :class="item.checked ? 'selected' : ''" class="shipitem flex" @click="toggleSelected(item, index)">
						<el-checkbox v-model="item.checked"></el-checkbox>
						<div style="flex: 1; margin-left: 18px; overflow: hidden">
							<div class="region">
								<span v-if="item.isDefault" class="tagbg tagred" type="text">默认</span>
								<span>{{ item.provinceName }}{{ item.cityName }}{{ item.districtName }}</span>
							</div>
							<div class="address" :title="item.detailAddress">{{ item.detailAddress }}</div>
							<div class="uinfo">
								{{ item.receiverName }}
								&nbsp;
								{{ item.receiverPhone }}
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 确定 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
	import { getCorporateGetAddress } from '@/api/user/address.js';
	export default {
		name: 'DialogAddress',
		props: {
			checkedAddressId: {
				type: Number,
				default: 0
			}
		},

		data() {
			return {
				dialogVisible: false,
				list: [],
				selectedAddressId: null
			};
		},
		created() {
			this.getCorporateGetAddress();
		},
		watch: {
			checkedAddressId(val) {
				this.list.forEach(item => {
					item.checked = item.id === val;
				});
			},
			dialogVisible(val) {
				if (val) {
					this.selectedAddressId = null;
				}
			}
		},
		methods: {
			toggleSelected(item, index) {
				if (this.list.length > 1) {
					this.list.forEach(item => {
						item.checked = false;
					});
				}
				item.checked = !item.checked;
				this.$set(this.list, index, item);
				this.selectedAddressId = item.id;
			},

			//获取收货地址列表
			async getCorporateGetAddress() {
				const res = await getCorporateGetAddress({});
				this.list = res.data.rows;
				// this.list.forEach(item => {
				//     if(item.id == this.checkedAddressId) {
				//         item.checked = true;
				//         this.selectedAddressId = item.id;
				//     }
				// });
			},

			handleConfirm() {
				// console.log('Selected Address ID:', this.selectedAddressId);
				this.$emit('confirmAddress', this.selectedAddressId);
			}
		}
	};
</script>

<style lang="less" scoped>
	// 弹出框重置样式
	/deep/ .el-dialog__header {
		border-bottom: 1px solid #e8e8e8;
		margin-right: 0;
		background: #f5f7fa;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #3a434f;
		font-size: 24px;
	}

	/deep/ .el-dialog__footer {
		border-top: 1px solid #e8e8e8;
		padding: 18px;
	}

	/deep/ .el-dialog__body .el-form-item__label {
		line-height: 26px;
	}
	.shiplist {
		flex-wrap: wrap;
		margin-left: -10px;
		margin-right: -10px;

		.selected {
			border: 1px solid #1474e2;
		}
	}
	.shipitem {
		cursor: pointer;
		margin: 0 10px 20px 10px;
		padding: 20px;
		border: 1px solid #cccccc;
		border-radius: 3px;
		color: #333333;
		font-size: 14px;
		line-height: 1.8;
		flex: 0 1 23.8%;
		box-sizing: border-box;
		.address {
			margin-bottom: 5px;
			font-weight: bold;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.region {
			span + span {
				margin-left: 5px;
			}
		}
		.button-box {
			text-align: right;
			color: #ec2b2d;
			visibility: hidden;
			cursor: pointer;
		}
	}
	.shipitem:nth-child(4n) {
		margin-right: 0;
	}
	.shipitem:hover .button-box {
		visibility: visible;
	}
</style>
